import { createContext } from 'react';

export const ShareTrayContext = createContext({ 
  isShareTrayOpen: false, 
  setIsShareTrayOpen: () => {} 
});
